import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '../../../context';
import debounce from 'lodash.debounce';

const SearchInput = () => {
    const dispatch = useDispatch();

    const updatePracticesListWithFilter = useCallback(
        (string) =>
            dispatch(actions.practiceWorkflow.setWorkflowFilter(string)),
        [dispatch]
    );

    const changeHandler = (event) => {
        updatePracticesListWithFilter(event.target.value);
    };

    const debouncedChangeHandler = useMemo(
        () => debounce(changeHandler, 300),
        // eslint-disable-next-line
        []
    );

    useEffect(() => {
        return () => {
            debouncedChangeHandler.cancel();
        };
    }, [debouncedChangeHandler]);

    return (
        <div id="searchBar" className="mb-3 practice-search-bar text-center">
            <input
                type="search"
                id="workflowPracticeSearch"
                className="p-2 w-66 text-center rounded"
                placeholder="Filter practices"
                onChange={(e)=>{
                    e.persist();
                    debouncedChangeHandler(e);
                }}
            />
        </div>
    );
};

export default SearchInput;
